import moment from "moment";
import axiosBackEnd from "../config/axios/axios-back-end";

// Get sftp job api
export const getSFTPJobData = async () => {
  const url = `/api/sftp/jobs`;
  const response = await axiosBackEnd.get(url);
  return response.data;
};
// Get sftp connection api
export const getSFTPConnectionData = async () => {
  const url = `/api/sftp/connections`;
  const response = await axiosBackEnd.get(url);
  return response.data;
};
// create sftp connection api
export const createSFTPConnectionData = async (data) => {
  const url = `/api/sftp/connections`;
  const response = await axiosBackEnd.post(url, data);
  return response.data;
};
// update sftp connection api
export const updateSFTPConnectionData = async ({ id, data }) => {
  const url = `/api/sftp/connections/${id}`;
  const response = await axiosBackEnd.put(url, data);
  return response.data;
};

// create SFTP Job api
export const createSFTPJobData = async (data) => {
  const url = `/api/sftp/jobs`;
  const response = await axiosBackEnd.post(url, data);
  return response.data;
};
// update SFTP Job api
export const updateSFTPJobData = async ({ id, data }) => {
  const url = `/api/sftp/jobs/${id}`;
  const response = await axiosBackEnd.put(url, data);
  return response.data;
};

// Delete sftp connection api
export const deleteSFTPConnectionData = async (id) => {
  const url = `/api/sftp/connections/${id}`;
  const response = await axiosBackEnd.delete(url);
  return response.data;
};

// Delete sftp job api
export const deleteSFTPJobData = async (id) => {
  const url = `/api/sftp/jobs/${id}`;
  const response = await axiosBackEnd.delete(url);
  return response.data;
};

// Get sftp Log api
export const getSFTPLogData = async (Logdata) => {
  const url = `/api/sftp/log/${Logdata?.jobId}`;

  const queryData = {
    from: Logdata?.businessDate?.[0]
      ? moment(Logdata.businessDate[0]).format("YYYY-MM-DD")
      : undefined,
    to: Logdata?.businessDate?.[1]
      ? moment(Logdata.businessDate[1]).format("YYYY-MM-DD")
      : undefined,
  };

  const response = await axiosBackEnd.get(url, {
    params: queryData,
  });
  return response.data;
};

export default {
  getSFTPJobData,
  deleteSFTPJobData,
  getSFTPLogData,
  getSFTPConnectionData,
  deleteSFTPConnectionData,
  createSFTPConnectionData,
  updateSFTPConnectionData,
  createSFTPJobData,
  updateSFTPJobData,
};
